import { TemplateApiUrls } from "@/modules/template/common/enum";
import type {
  ICreateOwnAccountsTransferTemplateRequest,
  IOwnAccountsTransferTemplate,
  IUpdateOwnAccountsTransferTemplateRequest,
} from "@/modules/template/common/types";
import { withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const ownTransferTemplateApi = createApi({
  reducerPath: "ownTransferTemplateApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getOwnTransferTemplate: builder.query<IOwnAccountsTransferTemplate, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TemplateApiUrls.OwnAccountTransferTemplateV2}/${id}`,
      }),
      keepUnusedDataFor: 0,
    }),
    createOwnTransferTemplate: builder.mutation<string, ICreateOwnAccountsTransferTemplateRequest>(
      withIdempotency<ICreateOwnAccountsTransferTemplateRequest>(
        TemplateApiUrls.OwnAccountTransferTemplateV2
      )),
    updateOwnTransferTemplate: builder.mutation<string, IUpdateOwnAccountsTransferTemplateRequest>(
      {
        query: ({ data, id }) => ({
          url: `${TemplateApiUrls.OwnAccountTransferTemplateV2}/${id}`,
          method: "PUT",
          data,
        }),
      }),
  }),
});

export const {
  useGetOwnTransferTemplateQuery,
  useCreateOwnTransferTemplateMutation,
  useUpdateOwnTransferTemplateMutation,
} = ownTransferTemplateApi;
